/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createLarger } from '../../factoriesAny.js';
export var largerDependencies = {
  DenseMatrixDependencies,
  matrixDependencies,
  typedDependencies,
  createLarger
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesLarger.generated.js
// module id = 76
// module chunks = 2